<template lang="pug">
div
  div.gigs
    h4
      |Ben Schreiber's performing schedule starting January 1st,&nbsp
      span(v-if="!showHistory") {{ currentYear }}
      span(v-else) {{ gigList[0].startyear }}
      |.
    br
    p.small As of {{ today }}.
    br
    p.small
      b-link(@click="toggleHistory()") Toggle History
    br
    div(v-if="showHistory && !isBusy")
      div.gig-totals-wrapper
        div.gig-totals-plot(ref="plot")
          svg.gig-totals-graph(v-if="graphWidth", :width="graphWidth", :height="graphHeight", aria-hidden="true", focusable="false")
            g(:class="{ active: activeRow }")
              rect(v-for="(bar, i) in graphBars", :key="i", :x="bar.x", :y="bar.y", :width="bar.width", :height="bar.height", :style="{ y: bar.y + 'px', height: bar.height + 'px' }", rx="2")
          table.gig-totals(ref="totalsTable")
            thead
              tr
                th.stat-label
                th.year-col(v-for="entry in yearTotals", :key="entry.year") {{ entry.year }}
                th.total-col Total
            tbody
              tr(v-for="row in statRows", :key="row.key", :class="[row.class, { active: activeRow === row.key }]", @mouseenter="activeRow = row.key", @mouseleave="activeRow = null", @click="activeRow = row.key")
                th.stat-label(scope="row") {{ row.label }}
                td.year-col(v-for="entry in yearTotals", :key="entry.year") {{ entry[row.key] }}
                td.total-col {{ overallTotals[row.key] }}
      //-LineChart(:chart-data="lineChartData", :options="lineChartOptions")
    br
    p.center-loader(v-if="isBusy")
      b-spinner.align-middle.mx-2
      strong Loading...
    div.tables(v-bind:class="ready")
      b-table.mt-3#gigs(:items="gigList", :fields="fields", :busy="isBusy", :tbody-tr-class="rowClass", borderless)
        template(#cell(startyear)="data")
          span.small-caps.year-label(v-if="data.item.startyear > data.item.prevyear || data.index==0") {{ data.item.startyear }}
        template(#cell(startdateenddate)="data")
          span.next-gig-wrapper.d-none.d-md-block
            span.next-gig.bounce-right(v-if="data.item.nextgig == true")
              |next&nbsp
              b-icon-forward-fill
          span.cancel-wrapper
            //- span.cancel-icon-wrapper-mobile.d-none(v-b-tooltip.click.blur="{ customClass: 'custom-tooltip' }", title="Canceled",  tabindex="0")
            //-   b-icon-exclamation-circle-fill.ml-1
            span(v-if="data.item.enddate")
              span(v-if="data.item.startyear == data.item.endyear")
                span(v-if="data.item.startmonth == data.item.endmonth") {{ data.item.startdate | dateParse('MM/DD/YYYY') | dateFormat('MMM D') }}-{{ data.item.enddate | dateParse('MM/DD/YYYY') | dateFormat('D, YYYY') }}
                span(v-else) {{ data.item.startdate | dateParse('MM/DD/YYYY') | dateFormat('MMM D') }} - {{ data.item.enddate | dateParse('MM/DD/YYYY') | dateFormat('MMM D, YYYY') }}
              span(v-else) {{ data.item.startdate | dateParse('MM/DD/YYYY') | dateFormat('MMM D, YYYY') }} - {{ data.item.enddate | dateParse('MM/DD/YYYY') | dateFormat('MMM D, YYYY') }}
            span(v-else) {{ data.item.startdate | dateParse('MM/DD/YYYY') | dateFormat('dddd, MMM D, YYYY') }}
            span.cancel-icon-wrapper-desktop.d-none(v-b-tooltip="{ customClass: 'custom-tooltip' }" title="Canceled")
              b-icon-exclamation-circle-fill.ml-1
        template(#cell(band)="data")
          span.cancel-wrapper
            span {{ data.item.band }}
        template(#cell(citystateprovince)="data")
          span.cancel-wrapper
            span
              b.text-info {{ data.item.city.toUpperCase() }}
              |,&nbsp
              b {{ data.item.stateprovince }}
        template(#cell(event)="data")
          span.cancel-wrapper
            span(v-bind:class="data.item.category")
              b-link(v-if="data.item.link", :href="data.item.link", target="_blank")
                span {{ data.item.event }}
                b-icon-box-arrow-up-right.ml-1.text-muted.smaller
              span(v-else) {{ data.item.event }}
      div(v-if="!isBusy")
        br
        br
        br
        //div {{bandList}}
</template>

<script>
import LineChart from "@/components/LineChart.vue";

export default {
  name: "Gigs",
  components: {
    LineChart
  },
  data() {
    return {
      fields: [
        { key: "startyear", label: "" },
        { key: "startdateenddate", label: "Date" },
        "band",
        { key: "citystateprovince", label: "Location" },
        "event"
      ],
      // Rows of the transposed totals table, top to bottom
      statRows: [
        { key: "numDances", label: "Dances" },
        { key: "numCamps", label: "Camps" },
        { key: "numConcerts", label: "Concerts" },
        { key: "numOther", label: "Other" },
        { key: "numGigs", label: "Total Gigs", class: "total-row" },
        {
          key: "numDays",
          label: "Total Days with Gigs",
          class: "total-row"
        }
      ],
      // Measured layout of the bar graph drawn behind the totals table
      graphGeometry: null,
      graphWidth: 0,
      graphHeight: 0,
      activeRow: null,
      gigList: [],
      bandList: [],
      gigTotals: [],
      isBusy: true,
      ready: "notready",
      today: new Date().toLocaleString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      }),
      currentYear: new Date().getFullYear(),
      showHistory: false,
      lineChartData: {
        labels: [],
        datasets: []
      },
      lineChartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  computed: {
    // Per-year entries become the columns of the totals table, earliest first
    yearTotals() {
      return this.gigTotals.filter(entry => entry.year !== "Total:");
    },
    // The overall tally becomes the right-most column
    overallTotals() {
      return this.gigTotals.find(entry => entry.year === "Total:") || {};
    },
    // Every row's numbers, keyed by row, in year order
    graphSeries() {
      var series = {};
      this.statRows.forEach(function(row) {
        series[row.key] = this.yearTotals.map(function(entry) {
          return Number(entry[row.key]) || 0;
        });
      }, this);
      return series;
    },
    // One shared scale, so a row's bars stay comparable to any other row's
    graphMax() {
      var series = this.graphSeries;
      return (
        Object.keys(series).reduce(function(highest, key) {
          return Math.max(highest, Math.max.apply(null, series[key]));
        }, 0) || 1
      );
    },
    // What the bars currently show: the selected row's numbers, or the peak
    // across every row when nothing is selected
    graphValues() {
      var series = this.graphSeries;
      if (this.activeRow && series[this.activeRow]) {
        return series[this.activeRow];
      }
      return this.yearTotals.map(function(entry, index) {
        return Object.keys(series).reduce(function(highest, key) {
          return Math.max(highest, series[key][index]);
        }, 0);
      });
    },
    // Bar rects, recomputed whenever the selection changes so the heights
    // animate from one row's numbers to the next
    graphBars() {
      var geometry = this.graphGeometry;
      if (!geometry) return [];

      var max = this.graphMax;
      // Leaves a small gap so neighbouring bars stay distinct
      var gap = 4;

      return this.graphValues
        .map(function(value, index) {
          var col = geometry.cols[index];
          if (!col) return null;

          var top = geometry.inset + (1 - value / max) * geometry.span;
          return {
            x: col.left + gap / 2,
            y: top,
            width: Math.max(col.width - gap, 1),
            height: geometry.baseline - top
          };
        })
        .filter(Boolean);
    }
  },
  watch: {
    gigTotals() {
      this.scheduleMeasure();
    },
    showHistory() {
      this.scheduleMeasure();
    }
  },
  methods: {
    scheduleMeasure() {
      this.$nextTick(this.measureGraph);
    },
    // The bars are drawn in the table's own pixel space, so their geometry
    // has to be read back from the rendered table rather than assumed.
    measureGraph() {
      var plot = this.$refs.plot;
      var table = this.$refs.totalsTable;
      if (!plot || !table) {
        this.graphWidth = 0;
        this.graphGeometry = null;
        return;
      }

      var plotRect = plot.getBoundingClientRect();
      var headers = Array.from(table.querySelectorAll("thead th.year-col"));
      // Each bar is sized to the year column it belongs to
      var cols = headers.map(function(cell) {
        var rect = cell.getBoundingClientRect();
        return { left: rect.left - plotRect.left, width: rect.width };
      });
      if (cols.length < 2) {
        this.graphWidth = 0;
        this.graphGeometry = null;
        return;
      }

      // The tallest bar tops out just below the header row, never across it
      var thead = table.querySelector("thead");
      var inset =
        (thead ? thead.getBoundingClientRect().bottom - plotRect.top : 0) + 6;

      this.graphWidth = plotRect.width;
      this.graphHeight = plotRect.height;
      this.graphGeometry = {
        cols: cols,
        inset: inset,
        span: plotRect.height - inset,
        baseline: plotRect.height
      };
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      var classString = "";
      if (item.band && item.band != item.prevband) {
        classString = classString + " new-band";
      }
      if (item.band && item.band == item.prevband) {
        classString = classString + " same-band";
      }
      if (item.startyear > item.prevyear) {
        classString = classString + " new-year";
      }
      if (item.lastofyear === true) {
        classString = classString + " last-gig-of-year";
      }
      if (item.startyear < this.currentYear) {
        classString = classString + " d-none";
      }
      if (item.status === "canceled") {
        classString = classString + " canceled";
      }
      if (item.pastgig === true) {
        classString = classString + " past-gig";
      }
      return classString;
    },
    toggleHistory() {
      this.showHistory = !this.showHistory;
      if (this.showHistory === true) {
        this.currentYear = 1989;
      } else {
        this.currentYear = new Date().getFullYear();
      }
    },
    getGigs() {
      this.isBusy = true;
      this.ready = "notready";
      fetch(process.env.VUE_APP_GIGSHEET, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
        .then(response => response.json())
        .then(data => {
          var gigData = [];
          var bandData = [];
          var totalData = [];
          var currentTotal = {
            year: 0,
            numDances: 0,
            numConcerts: 0,
            numCamps: 0,
            numOther: 0,
            numGigs: 0,
            numDays: 0
          };
          var overallTotal = {
            year: 0,
            numDances: 0,
            numConcerts: 0,
            numCamps: 0,
            numOther: 0,
            numGigs: 0,
            numDays: 0
          };
          var bandSet = new Set();
          var startDate = [];
          var endDate = [];
          var curDate = new Date()
            .toLocaleString()
            .split(",")[0]
            .split("/");
          var curDay = Number(curDate[1]);
          var curMonth = Number(curDate[0]);
          var curYear = Number(curDate[2]);
          var prevBand = null;
          var prevYear = null;
          var numDays = 0;

          data.values.forEach(function(value, index) {
            startDate = value[2].split("/");
            endDate = value[3].length > 1 ? value[3].split("/") : startDate;
            if (value[3]) {
              numDays =
                (new Date(value[3]) - new Date(value[2])) / 1000 / 60 / 60 / 24;
            } else {
              numDays = 1;
            }

            var entry = {
              index: index,
              startdate: value[2],
              startmonth: startDate[0],
              startday: startDate[1],
              startyear: startDate[2],
              enddate: value[3],
              endmonth: endDate[0],
              endday: endDate[1],
              endyear: endDate[2],
              prevyear: prevYear || startDate[2],
              prevband: prevBand || value[4],
              band: value[4],
              city: value[5],
              stateprovince: value[6],
              event: value[7],
              category: value[8],
              status: value[9],
              link: value[10],
              lastofyear: false,
              nextgig: false,
              pastgig: false,
              numDays: numDays
            };

            // If this is the last gig of the year, set lastofyear to true
            if (prevYear && prevYear < startDate[2]) {
              gigData[index - 1]["lastofyear"] = true;
            }

            // If this is the last gig in the index, set lastofyear to true
            if (index + 1 == data.values.length) {
              entry["lastofyear"] = true;
            }

            // console.log(curDay + " " + curMonth + " " + curYear);
            // console.log(Number(entry["startday"]) + " " + Number(entry["startmonth"]) + " " + Number(entry["startyear"]));
            // if (gigData[index-1]) {
            //   console.log(Number(gigData[index-1]["startday"]) + " " + Number(gigData[index-1]["startmonth"]) + " " + Number(gigData[index-1]["startyear"]));
            // }

            if (
              gigData[index - 1] &&
              entry["startyear"] >= curYear &&
              entry["startmonth"] >= curMonth &&
              entry["startday"] >= curDay &&
              gigData[index - 1]["startyear"] <= curYear &&
              ((gigData[index - 1]["startmonth"] == curMonth &&
                gigData[index - 1]["startday"] < curDay) ||
                gigData[index - 1]["startmonth"] < curMonth)
            ) {
              entry["nextgig"] = true;
            }

            if (
              entry["endyear"] < curYear ||
              (entry["endyear"] == curYear && entry["endmonth"] < curMonth) ||
              (entry["endyear"] == curYear &&
                entry["endmonth"] == curMonth &&
                entry["endday"] < curDay)
            ) {
              entry["pastgig"] = true;
            }

            // Set prevyear to year of current entry
            prevYear = startDate[2];

            // Set prevband to band of current entry
            prevBand = value[4];

            // Add to the set of bands
            bandSet.add(entry.band);

            // Push entry into the list of gigs
            gigData.push(entry);

            if (index > 0) {
              if (
                gigData[index - 1] &&
                gigData[index - 1]["startyear"] < entry["startyear"]
              ) {
                currentTotal["year"] = gigData[index - 1]["startyear"];
                var totalEntry = {
                  year: currentTotal["year"],
                  numDances: currentTotal["numDances"],
                  numConcerts: currentTotal["numConcerts"],
                  numCamps: currentTotal["numCamps"],
                  numOther: currentTotal["numOther"],
                  numGigs: currentTotal["numGigs"],
                  numDays: currentTotal["numDays"]
                };
                totalData.push(totalEntry);
                currentTotal["year"] = entry["startyear"];
                currentTotal["numDances"] = 0;
                currentTotal["numConcerts"] = 0;
                currentTotal["numCamps"] = 0;
                currentTotal["numOther"] = 0;
                currentTotal["numGigs"] = 0;
                currentTotal["numDays"] = 0;
              }
              if (entry["category"] == "dance") {
                currentTotal["numDances"] += 1;
                currentTotal["numGigs"] += 1;
                overallTotal["numDances"] += 1;
                overallTotal["numGigs"] += 1;
              } else if (entry["category"] == "camp") {
                currentTotal["numCamps"] += 1;
                currentTotal["numGigs"] += 1;
                overallTotal["numCamps"] += 1;
                overallTotal["numGigs"] += 1;
              } else if (entry["category"] == "concert") {
                currentTotal["numConcerts"] += 1;
                currentTotal["numGigs"] += 1;
                overallTotal["numConcerts"] += 1;
                overallTotal["numGigs"] += 1;
              } else {
                currentTotal["numOther"] += 1;
                currentTotal["numGigs"] += 1;
                overallTotal["numOther"] += 1;
                overallTotal["numGigs"] += 1;
              }
              currentTotal["numDays"] += numDays;
              overallTotal["numDays"] += numDays;
            }
          });

          var totalEntry = {
            year: currentTotal["year"],
            numDances: currentTotal["numDances"],
            numConcerts: currentTotal["numConcerts"],
            numCamps: currentTotal["numCamps"],
            numOther: currentTotal["numOther"],
            numGigs: currentTotal["numGigs"],
            numDays: currentTotal["numDays"]
          };
          totalData.push(totalEntry);

          // Reformat totals for line chart
          const years = [];
          const numDances = [];
          const numConcerts = [];
          const numCamps = [];
          const numOther = [];
          const numGigs = [];
          const numTotalDays = [];

          totalData.forEach(entry => {
            years.push(entry.year);
            numDances.push(entry.numDances);
            numConcerts.push(entry.numConcerts);
            numCamps.push(entry.numCamps);
            numOther.push(entry.numOther);
            numGigs.push(entry.numGigs);
            numTotalDays.push(entry.numDays);
          });

          var overallTotalEntry = {
            year: "Total:",
            numDances: overallTotal["numDances"],
            numConcerts: overallTotal["numConcerts"],
            numCamps: overallTotal["numCamps"],
            numOther: overallTotal["numOther"],
            numGigs: overallTotal["numGigs"],
            numDays: overallTotal["numDays"]
          };
          totalData.push(overallTotalEntry);

          gigData.shift(); // Remove first entry (header line)
          bandData = Array.from(bandSet);
          bandData.sort();
          this.bandList = bandData;
          this.gigList = gigData;
          this.gigTotals = totalData;
          this.lineChartData.labels = years;
          this.lineChartData.datasets[0] = {
            label: "Dances",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: numDances
          };
          this.lineChartData.datasets[1] = {
            label: "Concerts",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: numConcerts
          };
          this.lineChartData.datasets[2] = {
            label: "Camps",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: numCamps
          };
          this.lineChartData.datasets[3] = {
            label: "Other",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: numOther
          };
          this.lineChartData.datasets[4] = {
            label: "Total",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: numGigs
          };
          this.lineChartData.datasets[5] = {
            label: "Total Days",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: numTotalDays
          };
          this.isBusy = false;
          this.ready = "ready";
        });
    }
  },
  created() {
    this.getGigs();
  },
  mounted() {
    window.addEventListener("resize", this.scheduleMeasure);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.scheduleMeasure);
  }
};
</script>

<style scoped lang="less">
.tables {
  opacity: 0;

  -webkit-transition: opacity 2.8s;
  -moz-transition: opacity 2.8s;
  transition: opacity 2.8s;

  &.ready {
    opacity: 1;
    overflow-x: scroll;
  }
}

.b-table {
  max-width: var(--max-width);
  margin: 0px auto;

  a {
    color: var(--primary-color);
    text-decoration: none;
  }
}

.smaller {
  font-size: 0.8rem;
  padding-bottom: 0.1rem;
}

// Bars leave immediately, then coast a long way into their new heights
@graph-transition: 0.6s cubic-bezier(0.16, 1, 0.3, 1);

// Transposed totals table: years across the top, categories down the side
.gig-totals-wrapper {
  max-width: var(--max-width);
  margin: 0px auto;
  overflow-x: auto;
  text-align: center;
}

// Shrink-wraps the table so the sparkline layer can be positioned against it
.gig-totals-plot {
  position: relative;
  display: inline-block;
}

.gig-totals-graph {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;

  // A single set of bars whose heights animate between rows. y/height are set
  // as CSS geometry properties so they can transition; the matching attributes
  // stay on the element as a fallback where those properties aren't supported.
  rect {
    fill: var(--graph-color);
    transition: fill @graph-transition, y @graph-transition,
      height @graph-transition;
  }

  // Selecting a row brings its bars forward
  g.active rect {
    fill: var(--graph-color-active);
  }
}

table.gig-totals {
  position: relative;
  margin: 0px auto;
  border-collapse: collapse;
  white-space: nowrap;
  // Relative unit so the mobile vw-based sizing on .gigs still applies
  font-size: 0.9em;

  th,
  td {
    font-weight: normal;
    text-align: center;
    padding: 1.5rem 0.75rem;
  }

  thead th {
    border-bottom: var(--hr-width) solid var(--secondary-color);
  }

  .stat-label {
    text-align: left;
    padding-left: 0.75rem;
    padding-right: 1.5rem;
  }

  // Highlight tracks the pointer immediately; only the graph and its divider
  // are worth easing
  tbody tr {
    cursor: pointer;

    // Translucent so the graph behind the row still reads through it
    &:hover,
    &.active {
      background-color: rgba(128, 128, 128, 0.12);
    }
  }

  .total-col {
    border-left: var(--hr-width) solid var(--tertiary-color);
  }

  // The two aggregate rows read as a summary of the ones above them
  tr.total-row {
    th,
    td {
      font-weight: bold;
    }
  }
}
</style>
